import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=c279ea00&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=c279ea00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c279ea00",
  null
  
)

export default component.exports